import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .padding-form {
    padding: 0 1em 1em 1em;
  }

  .row {
    margin-bottom: 0.5em;
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }
`;

export const FileDropZone = styled.div`
  border: 2px dashed ${props => (props.isDragging ? Colors.Color4 : '#cccccc')};
  border-radius: 8px;
  padding: 1.5rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${props => (props.isDragging ? 'rgba(66, 133, 244, 0.05)' : 'transparent')};

  &:hover {
    border-color: ${Colors.Color4};
    background: rgba(66, 133, 244, 0.02);
  }
`;

export const FileDropZoneContent = styled.div`
  color: ${Colors?.text_Color_1};
`;

export const FilePreview = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border-radius: 8px;
`;

export const FilePreviewIcon = styled.div`
  font-size: 2rem;
`;

export const FilePreviewInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const FilePreviewName = styled.div`
  font-weight: 500;
  color: ${Colors?.text_Color_1};
`;

export const FilePreviewSize = styled.div`
  font-size: 0.85rem;
  color: ${Colors?.text_Color_2};
`;

export const RemoveFileButton = styled.button`
  background: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.2rem;
  transition: background 0.2s;

  &:hover {
    background: #d32f2f;
  }
`;

export const AddButton = styled.button`
  background: #ffffff10;
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${Colors.text_Color_1};
  font-size: 0.65em;
  font-weight: 400;
  cursor: pointer;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background;

  &:hover {
    background: #ffffff20;
  }
  &:active {
    background: #ffffff30;
  }
  &:focus {
    box-shadow: 0 0 0 2px ${Colors.primary_Color_1};
  }
  &:disabled {
    background: #ffffff05;
    color: #ffffff50;
    cursor: not-allowed;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: 300;
  cursor: pointer;
  height: 24px;
  width: 24px;
  transition-timing-function: ease-in-out;
  transition-duration: 300ms;
  transition-property: background, border;

  &:hover {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
  &:active {
    background: #ffffff10;
    border: 1px solid #ffffff25;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardTitle = styled.h3`
  color: ${Colors.text_Color_1};
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
`;

export const CardSubTitle = styled.p`
  color: ${Colors.text_Color_1};
  font-size: 0.85rem;
  font-weight: 400;
  margin: 0;
  opacity: 0.8;
`;

export const LeiturasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 1.4rem 1.4rem 1.4rem;
`;

export const LeiturasFilterContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 12px;
  background-color: ${Colors.bgCardColor};
  border: 1px solid ${Colors.Border_Color_1};
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 16px -4px;
`;

export const LeiturasTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.bgCardColor};
  border-radius: 8px;
  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 16px -4px;
  max-height: 200px;
  overflow-y: auto;
`;

export const LeiturasTableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  width: 100%;
  padding: 12px 16px;
  gap: 12px;
  background-color: #6796cf;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  position: sticky;
  top: 0;
  z-index: 1;

  font-size: 0.85rem;
  color: #fff;
  font-weight: 500;
`;

export const LeiturasTableBody = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  align-items: center;
  width: 100%;
  padding: 10px 16px;
  gap: 12px;

  font-size: 0.85rem;
  color: ${Colors.text_Color_1};
  font-weight: 300;

  border-bottom: 1px solid ${Colors.Border_Color_1};

  &:last-child {
    border-bottom: none;
  }
`;

export const LeiturasTableEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  gap: 8px;

  font-size: 0.85rem;
  color: ${Colors.text_Color_1};
  opacity: 0.7;
  text-align: center;
`;

export const PreviewButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: ${Colors.Color4};
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    /* background: ${Colors.Color11}; */
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: ${Colors.Color13};
  border-radius: 12px;
  overflow: hidden;
  max-height: 90vh;
  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem;
  border-bottom: 1px solid ${Colors.Border_Color_1};
  flex-shrink: 0;
`;

export const ModalTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${Colors.text_Color_1};
  margin: 0;
`;

export const ModalCloseButton = styled.button`
  background: transparent;
  border: none;
  font-size: 1.5rem;
  color: ${Colors.ftColor2};
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;

  &:hover {
    color: ${Colors.ftColor1};
    background: ${Colors.bgCardColor};
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  padding: 1.5rem;
  overflow-y: auto;
  color: ${Colors.text_Color_1};
  background: ${Colors.Color13};
  max-height: calc(90vh - 180px);

  p {
    font-size: 1rem;
    line-height: 1.6;
    color: ${Colors.text_Color_1};
    font-weight: 300;
    margin: 0.5em 0;
  }

  ul,
  ol {
    padding-left: 1.5rem;
    margin: 0.5em 0;
    color: ${Colors.text_Color_1};
    font-size: 1rem;
  }

  li {
    margin: 0.25em 0;
    line-height: 1.6;
    color: ${Colors.text_Color_1};
    font-size: 1rem;
  }

  ul li {
    list-style-type: disc;
  }

  ol li {
    list-style-type: decimal;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${Colors.text_Color_1};
    margin: 1.5rem 0 0.75rem 0;
    font-weight: 600;
  }

  h1:first-child,
  h2:first-child,
  h3:first-child,
  h4:first-child,
  h5:first-child,
  h6:first-child {
    margin-top: 0;
  }

  h1 {
    font-size: 2rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 2rem;
  }

  h3 {
    font-size: 1.25rem;
  }

  hr {
    border: none;
    border-top: 2px solid ${Colors.Border_Color_1 || '#ddd'};
    margin: 2rem 0;
  }

  strong {
    font-weight: 700;
    color: ${Colors.text_Color_1};
  }

  em {
    font-style: italic;
  }

  a {
    color: ${Colors.ftColor3};
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  img,
  .tiptap-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 1em auto;
    display: block;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: zoom-in;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.02);
    }
  }

  .tiptap-link {
    color: ${Colors.Color4 || '#4285f4'};
    text-decoration: underline;

    &:hover {
      opacity: 0.8;
    }
  }

  blockquote {
    border-left: 4px solid ${Colors.Color4 || '#4285f4'};
    padding-left: 16px;
    margin: 1em 0;
    color: ${Colors.text_Color_2 || '#666'};
    font-style: italic;
  }

  code {
    background: ${Colors.Color12 || 'rgba(110, 118, 129, 0.4)'};
    padding: 3px 6px;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.75em;
    color: ${Colors.Color9 || '#e8eaed'};
    border: 1px solid ${Colors.Color5 || 'rgba(255, 255, 255, 0.1)'};
  }

  pre {
    background: ${Colors.Color12 || 'rgba(110, 118, 129, 0.4)'};
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin: 1em 0;
    border: 1px solid ${Colors.Color5 || 'rgba(255, 255, 255, 0.1)'};
    font-size: 0.85em;

    code {
      background: transparent;
      padding: 0;
      color: ${Colors.Color9 || '#e8eaed'};
      border: none;
    }
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  border-top: 1px solid ${Colors.Border_Color_1};
  background: ${Colors.Color8};
  flex-shrink: 0;
`;

export const ModalButton = styled.button`
  padding: 0.75rem 1.5rem;
  background: ${props => (props.secondary ? 'transparent' : Colors.bgButton1)};
  border: 1px solid ${props => (props.secondary ? Colors.Border_Color_1 : 'transparent')};
  color: ${props => (props.secondary ? Colors.Color9 : Colors.ftColor4)};
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
